import React, { forwardRef } from 'react'
import AntdSwitch from 'antd/lib/switch'
import type { SwitchProps as AntdSwitchProps } from 'antd/lib/switch'
import { connectReadonlyComponent } from '../connect'

import 'antd/lib/switch/style'

export * from 'antd/lib/switch'

export type SwitchProps = AntdSwitchProps & {
  readonly?: boolean
}

export const Switch = connectReadonlyComponent(AntdSwitch, (props) => (
  <AntdSwitch {...props} disabled />
))

Switch.displayName = 'Switch'

export default Switch
